/* eslint-disable no-bitwise */
/* eslint-disable @typescript-eslint/no-unused-expressions */
import { RestService } from './../services/rest.service';
import { AfterViewChecked, Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { StorageService } from '../services/storage.service';
import {
  IonRouterOutlet,
  LoadingController,
  Platform,
  ViewWillEnter,
  ViewWillLeave,
  MenuController,
} from '@ionic/angular';
import { App } from '@capacitor/app';
import { TranslatePipe } from '@ngx-translate/core';
import { environment } from 'src/environments';
import { AuthService } from '../services/auth.service';
import { CurrentUserService } from '@ews/users-management';
import { filter, take } from 'rxjs/operators';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent
  implements AfterViewChecked, OnInit, ViewWillLeave, ViewWillEnter
{
  public loginForm: UntypedFormGroup;
  public mobileId: string;
  public logging = true;
  public inputPasswordType: 'password' | 'text' = 'password';
  public showError = false;
  public version = '';
  public permissionsError = '';

  private loadingDialog: HTMLIonLoadingElement;

  constructor(
    public menuCtrl: MenuController,
    fb: UntypedFormBuilder,
    private router: Router,
    private rest: RestService,
    private auth: AuthService,
    private storage: StorageService,
    private loadingController: LoadingController,
    private platform: Platform,
    private routerOutlet: IonRouterOutlet,
    private translatePipe: TranslatePipe,
    private currentUserService: CurrentUserService
  ) {
    this.loginForm = fb.group({
      userName: '',
      password: '',
      pinCode: '',
      rememberMe: false,
    });

    this.platform.backButton.subscribeWithPriority(-1, () => {
      if (!this.routerOutlet.canGoBack()) {
        App.exitApp();
      }
    });
  }

  async ngOnInit() {
    this.version = environment.version;
    await this.showLoading();
    this.initializeApp();
  }

  async ngAfterViewChecked() {
    this.permissionsError = this.auth.loginError;
  }

  ionViewWillLeave(): void {
    this.loginForm.setValue({
      userName: '',
      password: '',
      pinCode: '',
      rememberMe: false,
    });
  }

  ionViewWillEnter() {
    this.menuCtrl.enable(false);
    this.storage.get('hashcode').then((val) => {
      if (!val || val.length === 0) {
        this.mobileId = this.generateUUID();
        this.storage.storeMobileId('hashcode', this.mobileId);
      } else {
        this.mobileId = val;
      }
    });
  }

  async showLoading() {
    this.loadingDialog = await this.loadingController.create({
      message: this.translatePipe.transform('LOADING'),
    });

    this.loadingDialog.present();
  }

  generateUUID() {
    let dt = new Date().getTime();
    const uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(
      /[xy]/g,
      (c) => {
        const r = (dt + Math.random() * 16) % 16 | 0;
        dt = Math.floor(dt / 16);
        return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
      }
    );
    return uuid;
  }

  public login(): void {
    this.loginForm.markAsTouched();
    this.auth.loginError = '';
    this.permissionsError = '';
    if (this.loginForm.valid) {
      const dto = this.loginForm.getRawValue();
      this.auth.loginNew(dto.rememberMe, dto.userName, dto.password).subscribe({
        next: (result: boolean) => {
          console.log('Login result => ', result);
          if (result) {
            this.showError = false;
            this.rest.username$
              .pipe(
                filter((username) => !!username),
                take(1)
              )
              .subscribe(() => {
                this.router.navigate(['']);
                this.tryToStoreMobileId();
              });
          } else {
            this.showError = true;
            this.loginForm.reset({
              userName: '',
              password: '',
              rememberMe: false,
            });
          }
        },
        error: () => {
          this.showError = true;
          this.loginForm.reset({
            userName: '',
            password: '',
            rememberMe: false,
          });
        },
      });
    }
  }

  public togglePassword(): void {
    this.inputPasswordType === 'password'
      ? (this.inputPasswordType = 'text')
      : (this.inputPasswordType = 'password');
  }

  private async initializeApp() {
    this.storage.get('hashcode').then((val) => {
      if (val && val.length > 0) {
        this.mobileId = val;
        this.auth.loginNewMobile(this.mobileId).subscribe({
          next: (result: boolean) => {
            if (result) {
              // Wait for loginAfterUserManagement to complete (triggered by app.module.ts)
              // by listening for the REST username to be set
              this.rest.username$
                .pipe(
                  filter((username) => !!username),
                  take(1)
                )
                .subscribe((username) => {
                  console.log(
                    'Auto-login successful, user context ready:',
                    username
                  );
                  this.logging = false;
                  this.loadingDialog.dismiss();
                  this.router.navigate(['']);
                });
            } else {
              this.logging = false;
              this.loadingDialog.dismiss();
            }
          },
          error: () => {
            this.logging = false;
            this.loadingDialog.dismiss();
          },
        });
      } else {
        this.mobileId = this.generateUUID();
        this.storage.storeMobileId('hashcode', this.mobileId);
        this.logging = false;
        this.loadingDialog.dismiss();
      }
    });
  }

  private tryToStoreMobileId() {
    this.auth.addMobileId(this.mobileId).subscribe({
      next: (val: any) => {
        console.log('next => ', val);
      },
      error: (error: any) => {
        console.log('error => ', error);
      },
    });
  }
}
